// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__8evpK","name":"styles_name__3WiK4","phone":"styles_phone__1CNmB"};